<template>
  <div class="dri-instructions">

    <div class="instructions-main">
      <div class="instructions-top-title">
        <h1>硬核少年目标责任书</h1>
        <div class="subtitle">DRI跟每个人的切身利益息息相关，请仔细阅读您的目标责任书并签字确认</div>
      </div>
      <div style="width:100%;height:1px;background:#e5e5e5;margin-bottom:20px"></div>
      <div class="instructions-detail">
        <div v-for="(item,index) in detailInfo" :key="index">
          <div class="detail-primary-title">
            <h3>{{index+1}}、{{item.title}}</h3>
          </div>
          <div v-for="(items,i) in item.info" class="detail-secondary-title">
            {{index+1}}.{{i+1}}、 {{items.title}}
            <div v-for="(thirdLevel,k) in items.info " class="detail-tertiary-title">
              {{index+1}}.{{i+1}}.{{k+1}}、 {{thirdLevel.title}}

            </div>
          </div>

        </div>
      </div>
      <div style="width:1200px;height:1px;background:rgba(217,217,217,1);margin-left:-24px;margin-bottom:20px"></div>
      <div class="instructions-autograph" @click="showSignArea()" v-if="!signImg" :class="{'show-hand':showApplyBtn === 'show'}">
        签名确认处

      </div>
      <img :src="signImg" alt="" v-if="!!signImg" class="instructions-autograph"  @click="showSignArea()"  :class="{'show-hand':showApplyBtn === 'show'}"/>
    
    </div>
    <div class="operator-button">
      <el-button type="primary" @click="submitParams()" :loading="lodingBtn" v-if="showApplyBtn === 'show'">提交审核</el-button>

    </div>
<el-dialog
  title="手写签名"
  :visible.sync="dialogVisible"
  width="800px"
  :close-on-click-modal="false"
 >
<div class="all-color-board">
<div v-for="(item,index) in liColors" :style="{background:`${item}`}" class="color-board" @click="checkColor(item,index)" >
    <div :class="{'checked-border':index===checkColorIndex}"></div>
</div>

</div>
<div  @mousedown="getClick()" style="position:relative">
<h1 style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);" v-if="showPlaceholder" class="sign-pic-info">请在此清晰书写您的姓名</h1>
<vue-esign ref="esign" :width="800" :height="365" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" />
</div>
      
  <span slot="footer" class="dialog-footer">
    <el-button @click="handleReset" style="color:rgb(77,78,81);background:white;border-color:none;">清 除</el-button>
    <el-button type="primary" @click="handleGenerate" :disabled="surePic">确 定</el-button>
  </span>
</el-dialog>

  </div>
</template>
<script>
import "./Index.less";
import { CreateDri } from "@/API/api";
  export default {
    data() {
      return {
        isCrop: false, //是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
        lineColor: '#000000',//线条颜色
        lineWidth:8,//线条粗细
        checkColorIndex:0,
        dialogVisible:false,
         liColors: ['#000000', '#2D8EF8', '#E02020'],
        detailInfo: [{
            title: '目的与目标',
            info: [{
              title: '为了对事业部/事业中心所有成员的业绩、能力、态度进行客观评价，达到事业 部/事业中心成员与团队共赢，以达成公司成长与培养业务人才尤其是领导人才之目的， 特制定《硬核少年目标责任书》(<Directly Responsible Individual of NormcoreR >，以下简称 DRI)。'
            }]
          },
          {
            title: '适用范围',
            info: [{
              title: '事业部/事业中心所有成员'
            }]
          },
          {
            title: '事业部/事业中心的考核原则',
            info: [{
                title: '全面与公开原则。 公司将根据各岗位、职位的不同， 确定相应的考核规程与评价标准， 并对事业部/事业中心成员公开。'
              },
              {
                title: '客观与公正原则。对事业部/事业中心成员的任何考核都有明确的考核标准，以数据为依据，客观反应事业部/事业中心成员的实际情况， 同岗位同标准，避免因个人或者其他主观因素影响考核结果。'
              }
            ]

          },
          {
            title: '考核周期',
            info: [{
                title: '2022 年度考核周期为 2022  年 1  月 1 日至 2023  年 3  月 31 日',

              },
            ]

          },
            {
            title: 'DRI 的评估',
            info: [{
                title: 'DRI 的评定方案与结果由硬核少年团团长 (Captain) 根据公司整体战略规划进行测算、提出，报人力资源中心、财务管控中心及战略运营中心复核，并经总经理确认后执行；',
            },
                  {
                    title: 'DRI 的评定由提报者 N+1 、Captain 及战略运营中心、人力资源中心、财务管控中心对相应评定内容负责。',
                  }
              
            ]

          },
          {
            title: '事业部/事业中心成员须知',
            info: [{
                title: '事业部/事业中心成员接受 N+1 、团长(Captain) 及公司战略运营中心、人力资 源中心、财务管控中心的管理；',
            },
                  {
                    title: '事业部/事业中心成员签署 DRI，按照 DRI 之规定履职，遵守公司相关业务管理 的办法，接受 N+1 、团长(Captain) 及战略运营中心、人力资源中心、财务管控中心的考核，经总经理确认后生效；',
                  },
                       {
                    title: '事业部/事业中心成员根据所属职位身份不同，考核相应的业务指标，享受相应的奖金类型(具体参考当年相应的激励制度) ；',
                  },
                       {
                    title: '事业部/事业中心成员若感受到任何不公正待遇，可以向SDC 邮箱 (sdc@normcore.com ) 提出投诉，SDC 将赋权合适人选进行处理；',
                  },  
                     {
                    title: '保密与竞业限制规则',
                    info:[{
                      title:'事业部/事业中心所有成员承诺对协议信息的严格保密。未经公司事先书面许可，不得以任何方式或形式复制或散布，或向任何其他人披露部分或全部信息，但在 必要的情况下， 向相关法律顾问、SDC 披露除外。',
                    },
                    { 
                      title:'事业部/事业中心所有成员自离职之日起 2 年内不直接或间接地聘用或企图聘用本公司员工，除非另有书面约定；',
                    },
                     { 
                      title:'事业部/事业中心所有成员在离开团队 2 年之内，不得单方面与本公司任 何客户发生任何形式(包括直接/间接)的商务合作，除非另有书面约定；',
                    },
                     { 
                      title:'任何一方违反本协议约定内容，守约方有权要求违约方支付违约金人民 币壹佰万元整(RMB 1,000,000)元 。',
                    }
                    ]
                  },
            ]
          },
          {
             title: '其他',
            info: [{
                title: '未尽事宜将通过文件增补、邮件以及凌波创识(Excalibur)公告等方式进行通知；',
            },
            {
              title:'本文件解释权归人力资源中心所有。'
            }
            ]
          }
        ],
        signImg:this.$route.query.signPic,
        lodingBtn:false,
        showApplyBtn:this.$route.params.btnSave_visible,
        showPlaceholder:true,
        surePic:true,
      }
    },
    methods: {
      getClick(){
        this.showPlaceholder=false;
        this.surePic=false;
        console.log('======')
      },
      showSignArea(){
        if(this.showApplyBtn === 'show'){
          this.dialogVisible=true
        }
      },
      submitParams(){

      if(!this.signImg){
      this.$notify({
      title: "失败",
      message: '需确认签名后才可提交审核',
      type: "error",
      duration: 2000,
      });
      }else{
      this.lodingBtn=true;
      let params=JSON.parse(sessionStorage.getItem('creatDriParams'));
      params.signPic=this.signImg
      this.$http
      .post(CreateDri.driobjectset, this.qs.stringify({ ...params }), {
      headers: { Authorization: "Bearer " + this.$cookie.get("token") },
      })
      .then((res) => {
      const { data } = res;
      if (data.retCode === 0) {
      this.$notify({
      title: "成功",
      message: "更新成功",
      type: "success",
      duration: 2000,
      });
      sessionStorage.removeItem('creatDriParams');
      this.lodingBtn=false;
      this.$router.push({
      name: "driIndex",
      });
      } else if (data.retCode === 100014) {
      this.$cookie.delete("token");
      this.$router.push({
      name: "driIndex",
      });
      } else {
      this.$notify({
      title: "失败",
      message: data.retMsg,
      type: "error",
      duration: 2000,
      });
      }
      });
      }
      },
      checkColor(item,index){
      this.lineColor=item;
      this.checkColorIndex=index
      },
      handleReset() { // 清除
      this.showPlaceholder=true;
      this.surePic=true;
      this.$refs.esign.reset()
      },
      handleGenerate() { // 获取base64
      let _this = this
      // _this.dialogVisible=false;
      _this.$refs.esign.generate().then(res => {

      // this.signImg=res;
      // 转成文件
      let blob = _this.dataURLtoBlob(res)
      let tofile = _this.blobToFile(blob, '签名.jpg')
      console.log(tofile,'tofile','blob',blob)
      setTimeout(async () => {
      const formData = new FormData()
      formData.append('file', tofile, tofile.name)
      _this.dialogVisible=false;
      // ajax 请求
      this.$http
      .post('/api/ueditor/index?action=uploadfile&encode=utf-8', formData, {
      headers: { Authorization: "Bearer " + this.$cookie.get("token") },
      }).then((r)=>{
        console.log(r.data.url,'r.data.url')
      this.signImg= r.data.url;
      })
      })
      }).catch(err => {
      // _this.$toast('请输入签名')
         this.$message.error('请输入签名');
      // this.$notify({
      // title: "失败",
      // message:'请输入签名',
      // type: "error",
      // duration: 2000,
      // }); // 画布没有签字时会执行这里 'Not Signned'
      })
      },
      // 将base64转换为blob
      dataURLtoBlob(dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
      type: mime
      })
      },
      // 将blob转换为file
      blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
      },
      init(){
      //   let _this = this
      // // _this.dialogVisible=false;
      // _this.$refs.esign.generate().then(res => {

      // // this.signImg=res;
      // // 转成文件
      // let blob = _this.dataURLtoBlob(res)
      // let tofile = _this.blobToFile(blob, '签名.jpg')
      // console.log(tofile,'tofile','blob',blob)
      // setTimeout(async () => {
    
    
      // })
      // }).catch(err => {
      //   this.showpLACE=true;
      // // 画布没有签字时会执行这里 'Not Signned'
      // })
      }
      },
    mounted(){
     console.log(this.$route.params.btnSave_visible,'=====')
     this.init()
    }
      }

</script>
<style lang="less" scoped>

</style>